import { PromiseTypeSuffixes } from './promiseTypeSuffixes';

export const FETCH_FABRICATOR = 'fabricator/fetch_fabricator';
export const [
  FETCH_FABRICATOR_PENDING,
  FETCH_FABRICATOR_COMPLETED,
  FETCH_FABRICATOR_REJECTED
] = PromiseTypeSuffixes.map(suffix => `${FETCH_FABRICATOR}_${suffix}`);

export const INVALIDATE_FABRICATOR = 'fabricator/invalidate_fabricator';

export const FETCH_STONES = 'stones/fetch_stones';
export const FETCH_MASTER_STONES = 'stones/fetch_master_stones';
export const FETCH_USER_UPLOADED_STONES = 'stones/fetch_user_uploaded_stones';
export const FILTER_STONES_COLOR = 'stones/filter_stones_color';
export const FILTER_STONES_MATERIAL = 'stones/filter_stones_material';
export const SET_FILTER_STONES_MATERIAL = 'stones/set_filter_stones_material';
export const LINK_STONE_SUPPLIER_STONES = 'stones/link_stone_supplier_stones';
export const FETCHING_STONES_FILTERS = 'stones/fetching-filters';
export const FETCHED_STONES_FILTERS = 'stones/fetched-filters';
export const ADD_STONE_FILTER = 'stones/add-filter';
export const STONE_SUPPLIER_STONE_UPDATE_STORE_VALUE = 'stones/update-store-value';
export const STONE_CLEAR = 'stones/clear';

export const SET_FEATURES = 'features/set_features';
export const SET_MASTER_FEATURES = 'features/set_master_features';
export const SET_ACTIVE_FEATURE_GROUP_NAME = 'features/set_active_feature_group_name';

export const SET_SEARCH_TERM = 'search/set_search_term';

export const UPDATE_ENTITIES = 'entites/update_entities';
export const UPDATE_MASTER_ENTITIES = 'entites/update_master_entities';

export const UPDATE_TRANSIENT_FIELD = 'editor/update_transient_field';
export const UPDATE_TRANSIENT_FIELDS = 'editor/update_transient_fields';
export const LOAD_EDITOR = 'editor/load_editor';
export const UNLOAD_EDITOR = 'editor/unload_editor';
export const LOAD_STORED_TRANSIENT_UPDATES = 'editor/load_stored_transient_updates';
export const POST_LOAD_STORED_TRANSIENT_UPDATES = 'editor/post_load_stored_transient_updates';
export const SAVE_TRANSIENT_UPDATES = 'editor/save_transient_updates';
export const CLEAR_TRANSIENT_UPDATES = 'editor/clear_transient_updates';

export const CUSTOMERS_REQUEST = 'customers/get_request';
export const CUSTOMERS_SUCCESS = 'customers/get_success';

export const CUSTOMERS_STATUS_REQUEST = 'customers_status/request';
export const CUSTOMERS_STATUS_SUCCESS = 'customers_status/success';

export const EMPLOYEES_REQUEST = 'employees/get_request';
export const EMPLOYEES_SUCCESS = 'employees/get_success';

export const EMPLOYEES_STATUS_REQUEST = 'employees_status/request';
export const EMPLOYEES_STATUS_SUCCESS = 'employees_status/success';
export const EMPLOYEES_ADMIN_STATUS_REQUEST = 'employees_admin_status/request';
export const EMPLOYEES_ADMIN_STATUS_SUCCESS = 'employees_admin_status/success';
export const USER_STATUS_REQUEST = 'user_status/request';
export const USER_STATUS_SUCCESS = 'user_status/success';
export const EMPLOYEE_STATUS_REQUEST = 'employee_status/request';
export const EMPLOYEE_STATUS_SUCCESS = 'employee_status/success';
export const EMPLOYEE_EXPAND = 'employee/expand';

export const CUSTOMERS_INFO_REQUEST = 'customers_info/request';
export const CUSTOMERS_INFO_SUCCESS = 'customers_info/success';

export const CUSTOMERS_INFO_CLEAR = 'customers_info/clear';
export const CUSTOMERS_INFO_SET_HEADER_TEXT = 'customers_info/set_header_text';
export const CUSTOMERS_SET_LOGO_FILE = 'customers_info/set_logo_file';

export const USER_ENTITY_SET_GOOGLE_CALENDAR = 'user-entity/set-google-calendar';

export const CUSTOMERS_INFO_UPDATE_REQUEST = 'customers_info_update/request';
export const CUSTOMERS_INFO_UPDATE_SUCCESS = 'customers_info_update/success';

export const PERMISSIONS_REQUEST = 'permissions/request';
export const PERMISSIONS_SUCCESS = 'permissions/success';
export const PERMISSIONS_UPDATE_REQUEST = 'permissions_update/request';
export const PERMISSIONS_UPDATE_SUCCESS = 'permissions_update/success';
export const PERMISSIONS_SET = 'permissions/set';
export const PERMISSIONS_SET_ALL_CHECKED = 'permissions_update/set-all-checked';
export const PERMISSIONS_SET_SEARCH_TEXT = 'permissions_update/set-search-text';

export const FABRICATORS_REQUEST = 'fabricators/get_request';
export const FABRICATORS_SUCCESS = 'fabricators/get_success';
export const FABRICATORS_FAILURE = 'fabricators/get_failure';
export const FABRICATORS_STATUS_REQUEST = 'fabricators_status/request';
export const FABRICATORS_STATUS_SUCCESS = 'fabricators_status/success';
export const FABRICATORS_STATUS_FAILURE = 'fabricators_status/failure';

export const ENTITIES_ASSIGN_SAVING = 'entities/assign_saving';
export const ENTITIES_ASSIGN_SAVED = 'entities/assign_saved';
export const ENTITIES_ASSIGN_REMOVE = 'entities/assign_remove';

export const FABRICATORS_ALL_REQUEST = 'fabricators_all/get_request';
export const FABRICATORS_ALL_SUCCESS = 'fabricators_all/get_success';

export const STORES_ALL_REQUEST = 'stores_all/get_request';
export const STORES_ALL_SUCCESS = 'stores_all/get_success';

export const SALES_PEOPLE_REQUEST = 'sales_people/request';
export const SALES_PEOPLE_SUCCESS = 'sales_people/success';
export const SALES_PERSON_ASSIGN_SUCCESS = 'sales_people_assign/success';
export const SALES_PERSON_SELECT = 'sales_people/select';

export const STORES_REQUEST = 'stores/get_request';
export const STORES_SUCCESS = 'stores/get_success';
export const STORES_FAILURE = 'stores/get_failure';
export const STORES_STATUS_REQUEST = 'stores_status/request';
export const STORES_STATUS_SUCCESS = 'stores_status/success';
export const STORES_STATUS_FAILURE = 'stores_status/failure';

export const SITES_REQUEST = 'sites/get_request';
export const SITES_SUCCESS = 'sites/get_success';
export const SITES_UPDATE_REQUEST = 'sites_status/request';
export const SITES_CHANGES_SAVING = 'sites_status/changes-saving';
export const SITES_CHANGES_SAVED = 'sites_status/changes-saved';
export const SITES_CANCEL_CHANGES = 'sites_status/changes-cancel';

export const VISUALIZER_MANAGEMENT_REQUEST = 'visualizer-management/get_request';
export const VISUALIZER_MANAGEMENT_SUCCESS = 'visualizer-management/get_success';
export const VISUALIZER_MANAGEMENT_UPDATE_REQUEST = 'visualizer-management/request';
export const VISUALIZER_MANAGEMENT_CHANGES_SAVING = 'visualizer-management/changes-saving';
export const VISUALIZER_MANAGEMENT_CHANGES_SAVED = 'visualizer-management/changes-saved';
export const VISUALIZER_MANAGEMENT_UPDATE_DELETE_LIST = 'visualizer-management/update-delete-list';

export const VISUALIZER_MANAGEMENT_SET_ACTIVE_TAB = 'visualizer-management/set-active-tab';
export const VISUALIZER_MANAGEMENT_SET_PRODUCT_JOURNEY = 'visualizer-management/set-product-journey';
export const VISUALIZER_MANAGEMENT_DEFAULTS_REQUEST = 'visualizer-management/defaults-request';
export const VISUALIZER_MANAGEMENT_DEFAULTS_SUCCESS = 'visualizer-management/defaults-success';
export const VISUALIZER_MANAGEMENT_GET_DEFAULTS = 'visualizer-management/get-defaults';
export const VISUALIZER_MANAGEMENT_SET_DEFAULTS = 'visualizer-management/set-defaults';
export const VISUALIZER_MANAGEMENT_POST_DEFAULTS = 'visualizer-management/post-defaults';
export const VISUALIZER_MANAGEMENT_SET_ACTIVE_DEFAULT_PRESET_INDEX = 'visualizer-management/set-active-default-preset-index';
export const VISUALIZER_MANAGEMENT_SET_PRESETS_RECEIVED = 'visualizer-management/set-presets-received';

export const NEW_SCOPE_CATEGORIES_REQUEST = 'new-scope/categories-request';
export const NEW_SCOPE_CATEGORIES_REQUEST_SUCCESS = 'new-scope/categories-request-success';
export const NEW_SCOPE_CATEGORIES_SET = 'new-scope/categories-set';
export const NEW_SCOPE_CATEGORIES_RESET = 'new-scope/categories-reset';
export const NEW_SCOPE_SET_CATEGORIES_VISUALIZER = 'new-scope/set-categories-visualizer';
export const NEW_SCOPE_POST_NEW_CATEGORY_REQUEST = 'new-scope/post-new-category-request';
export const NEW_SCOPE_POST_NEW_CATEGORY_REQUEST_SUCCESS = 'new-scope/post-new-category-request-success';
export const NEW_SCOPE_DELETE_CATEGORY_REQUEST = 'new-scope/delete-category-request';
export const NEW_SCOPE_DELETE_CATEGORY_REQUEST_SUCCESS = 'new-scope/delete-category-request-success';
export const NEW_SCOPE_TOGGLE_CATEGORY_IMAGE_POPUP = 'new-scope/toggle-category-image-popup';
export const NEW_SCOPE_TOGGLE_FEATURE_GROUP_IMAGE_POPUP = 'new-scope/toggle-feature-group-image-popup';
export const NEW_SCOPE_SET_ACTIVE_CATEGORY_INDEX = 'new-scope/set-active-category-index';
export const NEW_SCOPE_SET_FEATURE_GROUP_SEARCH_VALUE = 'new-scope/set-feature-group-search-value';
export const NEW_SCOPE_SET_NEW_FEATURE_GROUP_IMAGE = 'new-scope/set-new-feature-group-image';
export const NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS = 'new-scope/set-fabricator-subscriptions';
export const NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS_RECEIVED = 'new-scope/set-fabricator-subscriptions-received';
export const NEW_SCOPE_SET_WIZARD_MODE = 'new-scope/set-wizard-mode';

// export const DISCOUNTS_REQUEST = 'discounts/discounts-request';
// export const DISCOUNTS_REQUEST_SUCCESS = 'discounts/discounts-request-success';
// export const DISCOUNTS_SET_DISCOUNTS = 'discounts/discounts-set-discounts';

export const DISCOUNTS_SECTIONS_REQUEST = 'discounts/discounts-request';
export const DISCOUNTS_SECTIONS_REQUEST_SUCCESS = 'discounts/discounts-request-success';
export const DISCOUNTS_SECTIONS_RESET = 'discounts/discounts-reset';
export const DISCOUNTS_SET_SECTIONS = 'discounts/discounts-set-sections';
export const DISCOUNTS_TOGGLE_ENABLE_WORKSHEET = 'discounts/toggle-enable-worksheet';
export const DISCOUNTS_SET_WORKSHEETS_ACTIVE_INDEX = 'discounts/set-worksheets-active-index';
export const DISCOUNTS_TOGGLE_ENABLE_WORKSHEET_FOR_CLIENTS = 'discounts/toggle-enable-worksheet-for-clients';
export const DISCOUNTS_REVERT_CHANGES = 'discounts/revert-changes';
export const DISCOUNTS_SET_WORKSHEET_COUNT = 'discounts/set-worksheet-count';
export const DISCOUNTS_SET_WIZARD_SELECTIONS_ACTIVE = 'discounts/set-wizard-selections-active';

export const FEATURES_FILTERS_TOGGLE_FEATURES_FILTERS_VISIBLE = 'features-filters/toggle-features-filters-visible';
export const FEATURES_FILTERS_GET_ALL_AVAILABLE_FILTERS_REQUEST = 'features-filters/get-all-filters-request';
export const FEATURES_FILTERS_SET_ALL_AVAILABLE_FILTERS = 'features-filters/set-all-available-filters';
export const FEATURES_FILTERS_GET_GROUP_AVAILABLE_FILTERS_REQUEST = 'features-filters/get-group-available-filters-request';
export const FEATURES_FILTERS_SET_GROUP_AVAILABLE_FILTERS = 'features-filters/set-group-available-filters';
export const FEATURES_FILTERS_SET_SELECTED_FILTERS = 'features-filters/set-selected-filters';
export const FEATURES_FILTERS_SET_EXPANDED_FILTERS = 'features-filters/set-expanded-filters';
export const FEATURES_FILTERS_SET_VISIBLE_FILTERS = 'features-filters/set-visible-filters';

export const JOB_BOARD = "job_board";
export const JOB_BOARD_LOADED = 'job_board/loaded';
export const JOB_BOARD_LOADING = 'job_board/loading';
export const JOB_BOARD_EXPAND_JOB = 'job_board/expand_job';
export const JOB_BOARD_UPDATE_JOB = 'job_board/update_job';
export const JOB_BOARD_SHOW_QUOTEEDIT_LAYER = 'job_board/show_quoteedit_layer';
export const JOB_BOARD_SHOW_LEADTYPE_DROPDOWN = 'job_board/show_leadtype_dropdown';
export const JOB_BOARD_SHOW_JOBSTATUS_DROPDOWN = 'job_board/show_jobstatus_dropdown';
export const JOB_BOARD_SHOW_LOG_WINDOW = 'job-board/show-log-window';
export const JOB_BOARD_JOB_STATUS_CHANGED = 'job-board/job-status-changed';
export const JOB_BOARD_LOG_ENTRIES_LOADING = 'job-board/job-log-entries-loading';
export const JOB_BOARD_LOG_ENTRIES_LOADED = 'job-board/job-log-entries-loaded';
export const JOB_BOARD_MESSAGE_HISTORY_LOADING = 'job-board/job-message-history-loading';
export const JOB_BOARD_MESSAGE_HISTORY_LOADED = 'job-board/job-message-history-loaded';
export const JOB_BOARD_LOG_UPDATE_TEXT = 'job-board/job-log-update-text';
export const JOB_BOARD_SHOW_FILTER = 'job-board/job-log-show-filter';
export const JOB_BOARD_SET_SEARCH_TERM = 'job-board/job-log-set-search-term';
export const JOB_BOARD_NOTE_SAVING = 'job-board/note-saving';
export const JOB_BOARD_NOTE_SAVED = 'job-board/note-saved';
export const JOB_BOARD_DOCUMENT_SAVING = 'job-board/document-saving';
export const JOB_BOARD_DOCUMENT_SAVED = 'job-board/document-saved';
export const JOB_BOARD_SHOW_FILTERS_POPUP = 'job-board/show-filters-popup';
export const JOB_BOARD_SET_FILTERS_POPUP_RESPONSE = 'job-board/set-filters-popup-response';
export const JOB_BOARD_SET_SORTING = 'job-board/set-sorting';
export const JOB_BOARD_RESET_PAGE = 'job-board/reset-page';
export const JOB_BOARD_SHOW_PAYMENT_POPUP = 'job-board/show-payment-popup';
export const JOB_BOARD_SET_SEND_EMAIL_CHECKBOXES = 'job-board/set-send-email-checkboxes';
export const JOB_BOARD_SHOW_EDIT_POPUP = 'job-board/show-edit-popup';
export const JOB_BOARD_EDIT_POPUP_SET_JOB_INFO = 'job-board/edit-popup-set-job-info';
export const JOB_BOARD_EDIT_POPUP_SET_JOB_CART_ITEMS = 'job-board/edit-popup-set-job-cart-items';
export const JOB_BOARD_EDIT_POPUP_SEARCH_TEXT = 'job-board/edit-popup-set-search-text';
export const JOB_BOARD_EDIT_POPUP_SET_ACTIVE_QUOTE_INDEX = 'job-board/edit-popup-set-active-quote-index';
export const JOB_BOARD_EDIT_POPUP_SET_IFRAME_LOADING = 'job-board/edit-popup-set-iframe-loading';
export const JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING = 'job-board/edit-popup-set-iframe-waiting';
export const JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING_RECEIPT = 'job-board/edit-popup-set-iframe-waiting-receipt';
export const JOB_BOARD_EDIT_POPUP_USE_FAB_PRICES = 'job-board/edit-popup-use-fab-prices';
export const JOB_BOARD_EDIT_POPUP_USE_TAXES = 'job-board/edit-popup-use-taxes';
export const JOB_BOARD_SET_RELATED_JOBS = 'job-board/set-related-jobs';

export const JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP = 'job-board/show-purchase-order-popup';
export const JOB_BOARD_PURCHASE_ORDER_POPUP_SET_STEP = "pricing/set-purchase-order-popup-step";
export const JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_NUMBER = "pricing/set-purchase-order-invoice-number";
export const JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_FILE = "pricing/set-purchase-order-invoice-file";
export const JOB_BOARD_PURCHASE_ORDER_POPUP_SET_ERROR_MESSAGE = "pricing/set-purchase-order-error-message";

export const CALENDAR_SHOW = 'calendar/show';
export const CALENDAR_SELECT_DAY = 'calendar/select-day';
export const CALENDAR_SELECT_MONTH = 'calendar/select-month';
export const CALENDAR_SELECT_YEAR = 'calendar/select-year';
export const CALENDAR_FETCHING_ENTRIES = 'calendar/fetching-entries';
export const CALENDAR_FETCHED_ENTRIES = 'calendar/fetched-entries';
export const CALENDAR_SHOW_SCHEDULE_ENTRY = 'calendar/show-schedule-entry';
export const CALENDAR_SHOW_SCHEDULE_ENTRY_DOCS_DOCUMENTS_ONLY = 'calendar/show-schedule-entry-notes-documents-only';
export const CALENDAR_SCHEDULE_ENTRY_SAVING = 'calendar/saving-schedule-entry';
export const CALENDAR_SCHEDULE_ENTRY_SAVED = 'calendar/saved-schedule-entry';

export const POPUP_ERROR_BOX = 'popup/error-box';
export const POPUP_ERROR_BOX_BUTTON_CLICK = 'popup/error-box-button-click';
export const POPUP_IN_PROGRESS = 'popup/in-progress';
export const POPUP_MESSAGE_BOX_SHOW = "popup/message-box-show";
export const POPUP_MESSAGE_BOX_COMPONENT_SHOW = "popup/message-box-component-show";

export const POPUP_ASSIGN_SALES_PERSON = 'popup/assign-sales-person';
export const POPUP_ASSIGN_ENTITY = 'popup/assign-entity';
export const POPUP_ASSIGN_ENTITY_RESET_STATUS = 'popup/assign-entity-reset-status';
export const POPUP_ASSIGN_ENTITY_CHECK_NAME = 'popup/assign-entity-check-name';
export const POPUP_ASSIGN_ENTITY_CHECK_LICENSED_ADMIN = 'popup/assign-entity-check-licensed-admin';
export const POPUP_ASSIGN_MULTIPLE_ENTITIES_CHECK = 'popup/assign-multiple-entities-check';
export const POPUP_ASSIGN_ENTITY_SAVING = 'popup/assign-entity-saving';
export const POPUP_ASSIGN_ENTITY_SAVE_TO_STORE = 'popup/assign-entity-save-to-store';
export const POPUP_ASSIGN_ENTITY_SAVED = 'popup/assign-entity-saved';
export const POPUP_NEW_ENTITY_SET_MASTER_PROFILE = 'popup/new-entity-set-master-profile';
export const POPUP_FILTER_GROUP_VISUAL_STYLE = 'popup/filter-group-visual-style';
export const POPUP_FILTER_GROUP_VISUAL_STYLE_SELECTED = 'popup/filter-group-visual-style-selected';
export const POPUP_FILTER_ASSIGN_TO_STONE = 'popup/filter-assign-to-stone';
export const POPUP_FILTER_ASSIGN_TO_FEATURES = 'popup/filter-assign-to-features';
export const POPUP_JOB_BOARD_EXPORT_SHOW = 'popup/job-board-export-show';

export const POPUP_CHOOSE_EMAIL_TEMPLATES_BOX_SHOW = 'popup/choose-email-templates-box-show';
export const POPUP_CHOOSE_EMAIL_TEMPLATE = 'popup/choose-email-template';
export const POPUP_SHOW_PAYMENT_GATEWAY_POPUP = 'popup/show-payment-gateway-popup';
export const POPUP_SHOW_MANUFACTURER_FILTERS_POPUP = 'popup/show-manufacturer-filters-popup';
export const POPUP_SHOW_CLIQ_SUBMID_INFO_POPUP = 'popup/show-cliq-submid-info-popup';
export const POPUP_SHOW_FABRICATORS_EXPORT_POPUP = 'popup/show-fabricators-export-popup';
export const POPUP_SHOW_CLONE_PRICING_PRESETS_INTO_POPUP = 'popup/show-clone-pricing-presets-into-popup';
export const POPUP_SHOW_CREDIT_CARD_POPUP = 'popup/show-credit-card-popup';
export const POPUP_SHOW_PERMISSIONS_POPUP = 'popup/show-permissions-popup';
export const POPUP_SET_RESET_PASSWORD_POPUP_STATE = 'popup/set-reset-password-popup-state';
export const POPUP_SET_DOCUSIGN_POPUP_STATE = 'popup/set-docusign-popup-state';
export const POPUP_SET_FINGER_SIGNATURE_POPUP_STATE = 'popup/set-finger-signature-popup-state';
export const POPUP_SET_QUESTION_POPUP_STATE = 'popup/set-question-popup-state';
export const POPUP_SET_SIGNATURE_POPUP_STATE = 'popup/set-signature-popup-state';

export const POPUP_TOGGLE_MODAL = 'popup/popup-toggle-modal';

export const POPUP_IMPORT_FABRICATOR = 'popup/popup-import-fabricator';

export const PRICING_PRESET_SET_PRESETS_RECEIVED = 'pricing-preset/set-presets-received';
export const PRICING_PRESET_UPDATE_VALUE = 'pricing-preset/update-value';
export const PRICING_PRESET_RESET = 'pricing-preset/reset';
export const PRICING_PRESET_SHOW = "pricing-preset/show";
export const PRICING_PRESET_ASSIGN_SHOW = 'pricing-preset/assign-show';
export const PRICING_PRESET_ASSIGN = 'pricing-preset/assign';
export const PRICING_PRESET_LOAD = "pricing-preset/load";
export const PRICING_PRESET_SET_SELECTED = 'pricing-preset/set-selected';
export const PRICING_PRESET_SET_PRESETS = 'pricing-preset/set-presets';
export const PRICING_PRESET_SELECT_STONE = 'pricing-preset/select-stone';
export const PRICING_PRESET_SET_SELECTED_STONES = 'pricing-preset/set-selected-stones';
export const PRICING_PRESET_DELETE = 'pricing-preset/delete';
export const PRICING_PRESET_SET_APPLY_TO_PRICE = 'pricing-preset/set-apply-to-price';

export const LOGIN = 'auth/login';
export const LOGOUT = 'auth/logout';
export const [
  LOGIN_PENDING,
  LOGIN_COMPLETED,
  LOGIN_REJECTED
] = PromiseTypeSuffixes.map(suffix => `${LOGIN}_${suffix}`);

export const FILTERS_LOADING = 'filters/loading';
export const FILTERS_LOADED = 'filters/loaded';
export const FILTERS_GROUP_ENABLE_UPDATING = 'filters/group-enable-updating';
export const FILTERS_GROUP_ENABLE_UPDATED = 'filters/group-enable-updated';
export const FILTERS_GROUP_EXPAND = 'filters/group-expand';
export const FILTERS_GROUP_UPDATE_PROP = 'filters/group-update-prop';
export const FILTERS_GROUP_EXPANDED_UPDATE_PROP = 'filters/group-expanded-update-prop';
export const FILTERS_GROUP_SET_ACTIVE_GROUP_ICON = 'filters/set-active-group-icon';
export const FILTERS_GROUP_SAVING = 'filters/saving';
export const FILTERS_GROUP_SAVED = 'filters/saved';
export const FILTERS_GROUP_NEW = 'filters/group-new';
export const FILTER_GROUP_CANCEL = 'filters/group-edit-cancel';
export const FILTER_GROUP_DELETING = 'filters/group-deleting';
export const FILTER_GROUP_DELETED = 'filters/group-deleted';
export const FILTER_GROUP_LOAD_WITH_VALUES = 'filters/group-load-with-values';
export const FILTER_GROUP_ITEM_SEARCH_TEXT = 'filters/group-item-search-text';
export const FILTER_GROUP_ITEM_ADD_ADDITIONAL_IMAGE = 'filters/group-item-add-additional-image';
export const FILTER_GROUP_ITEM_SET_ADDITIONAL_IMAGE_FILTERS = 'filters/group-item-set-additional-image-filters';
export const FILTER_GROUP_ITEM_DELETE_ADDITIONAL_IMAGE = 'filters/group-item-delete-additional-image';

export const FILTERS_ITEMS_LOADING = 'filters/item-loading';
export const FILTERS_ITEMS_LOADED = 'filters/item-loaded';
export const FILTERS_GROUP_ITEM_ENABLE_UPDATING = 'filters/group-item-enable-updating';
export const FILTERS_GROUP_ITEM_ENABLE_UPDATED = 'filters/group-item-enable-updated';
export const FILTERS_GROUP_ITEM_ORDER_UPDATING = 'filters/group-item-order-updating';
export const FILTERS_GROUP_ITEM_ORDER_UPDATED = 'filters/group-item-order-updated';
export const FILTERS_GROUP_ITEM_EXPAND = 'filters/filter-group-item-expand';
export const FILTERS_GROUP_ITEM_EXPANDED_UPDATE_PROP = 'filters/filter-group-item-expanded-set-prop';
export const FILTER_GROUP_ITEM_CANCEL = 'filters/group-item-edit-cancel';
export const FILTER_GROUP_ITEM_LOCK_TOGGLE = 'filters/group-item-lock-toggle';
export const FILTERS_GROUP_SET_ACTIVE_GROUP_ITEM_ICON = 'filters/set-active-group-item-icon';
export const FILTERS_GROUP_ITEM_NEW = 'filters/group-item-new';
export const FILTERS_GROUP_ITEM_SAVING = 'filters/item-saving';
export const FILTERS_GROUP_ITEM_SAVED = 'filters/item-saved';
export const FILTER_GROUP_ITEM_DELETING = 'filters/group-item-deleting';
export const FILTER_GROUP_ITEM_DELETED = 'filters/group-item-deleted';
export const FILTER_GROUP_ITEM_ADDITIONAL_POPUP_SHOW = 'filters/group-item-additional-popup-show';

export const FEATURE_INCLUSION_LOADED = "feature-inclusion/loaded";
export const FEATURE_INCLUSION_PRESET_CREATED = "feature-inclusion/preset-created";
export const FEATURE_INCLUSION_PRESET_DELETED = "feature-inclusion/preset-deleted";
export const FEATURE_INCLUSION_PRESET_ENABLE_GROUP = "feature-inclusion/group-enable";
export const FEATURE_INCLUSION_FEATURE_ENABLE = "feature-inclusion/feature-enable";
export const FEATURE_INCLUSION_ASSIGNEE_ADDED = "feature-inclusion/assignee-added";
export const FEATURE_INCLUSION_ASSIGNEE_REMOVED = "feature-inclusion/assignee-removed";
export const FEATURE_INCLUSION_SHOW_ADD_PRESET = "feature-inclusion/show-add-preset";
export const FEATURE_INCLUSION_SHOW_ADD_ASSIGNEE = "feature-inclusion/show-add-assignee";
export const FEATURE_INCLUSION_PAGE_CHANGE = "feature-inclusion/page-change";
export const FEATURE_INCLUSION_SET_SELECTED_PRESET = "feature-inclusion/set-selected-preset";
export const FEATURE_INCLUSION_SET_SEARCH_TERM = "feature-inclusion/set-search-term";
export const FEATURE_INCLUSION_VALUE_UPDATE = "feature-inclusion/update-value";
export const FEATURE_INCLUSION_ASSIGNEE_SET_SEARCH_TERM = "feature-inclusion/assignee-set-search-term";
export const FEATURE_INCLUSION_ASSIGNEE_SET_PAGE = "feature-inclusion/assignee-set-page";
export const FEATURE_INCLUSION_ASSIGNEE_SET_CHECK = "feature-inclusion/assignee-set-check";
export const FEATURE_INCLUSION_CUSTOMERS_LOADED = "feature-inclusion/customers-loaded";
export const FEATURE_INCLUSION_ASSIGNEES_SAVED = "feature-inclusion/assignees-saved";
export const FEATURE_INCLUSION_SELECTION_SELECT_FEATURE_GROUP = "feature-inclusion/selection-select-feature-gorup";
export const FEATURE_INCLUSION_SELECTION_CHECK_FEATURE_GROUP = "feature-inclusion/selection-check-feature-group";
export const FEATURE_INCLUSION_SELECTION_CHECK_FEATURE = "feature-inclusion/selection-check-feature";
export const FEATURE_INCLUSION_FABRICATOR_PRESET_LOADED = "feature-inclusion/fabricator-preset-loaded";
export const FEATURE_INCLUSION_SELECTION_SET_SEARCH_TERM = "feature-inclusion/fabricator-preset-set-search-term";
export const FEATURE_INCLUSION_SELECTION_PAGE_CHANGE = "feature-inclusion/fabricator-preset-page-change";

export const NEW_STONE_POPUP_SHOW = "new-stone-popup/show";
export const NEW_STONE_POPUP_ADD = "new-stone-popup/add";
export const EDIT_STONE_POPUP_SHOW = "edit-stone-popup/show";
export const EDIT_STONE_POPUP_UPDATE = "edit-stone-popup/update";
export const STONE_DELETE = 'stones/delete';

export const SHOW_SWITCH_USER_WINDOW = 'global/show-switch-user-info';
export const GET_PROTECTED_AREAS_BY_USER_REQUEST = 'global/get-protected-areas-by-user-request';
export const GET_PROTECTED_AREAS_BY_USER_RESPONSE = 'global/get-protected-areas-by-user-response';
export const DO_NOT_SHOW_LINK_WARNING = 'auth/do-not-show-link-warning';

export const SET_LANGUAGE = 'dashboard/set-language';
export const SET_NOTIFICATIONS_COUNT = 'dashboard/set-notifications-count';
export const SET_NOTIFICATIONS_RECEIVED = 'dashboard/set-notifications-received';
export const SET_NOTIFICATIONS_REQUESTED = 'dashboard/set-notifications-requested';
export const SHOW_SUCCESS_NOTIFICATION = 'dashboard/show-success-notification';
export const UPDATE_RELATED_JOBS_NOTIFICATIONS_COUNT = 'dashboard/update-related-jobs-notification-count';
export const SET_UI_POPUP_STATE = 'dashboard/set-ui-popup-state';

export const TOGGLE_SHOW_ASSIGN_QUOTE_POPUP = 'assign-quote-popup/toggle_show_assign_quote_popup';
export const SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT = 'assign-quote-popup/set_assign_quote_popup_search_text';
export const SET_ASSIGN_QUOTE_POPUP_EMPLOYEE = 'assign-quote-popup/set_assign_quote_popup_employee';
export const SET_ASSIGN_QUOTE_POPUP_CUSTOMER = 'assign-quote-popup/set_assign_quote_popup_customer';
export const SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT = 'assign-quote-popup/set_assign_quote_popup_success_text';
export const SET_ASSIGN_QUOTE_POPUP_USER_INFO = 'assign-quote-popup/set_assign_quote_popup_user_info';
export const SET_ASSIGN_QUOTE_POPUP_USER_INFO_ERRORS = 'assign-quote-popup/set_assign_quote_popup_user_info_errors';

export const SKU_FILTERS_GROUP_SAVING = 'sku-filters/saving';
export const SKU_FILTERS_GROUP_SAVED = 'sku-filters/saved';
export const SKU_FILTERS_LOADING = 'sku-filters/loading';
export const SKU_FILTERS_LOADED = 'sku-filters/loaded';
export const SKU_FILTERS_GROUP_ITEM_EXPANDED_UPDATE_PROP = 'sku-filters/filter-group-item-expanded-set-prop';
export const SKU_FILTERS_GROUP_ENABLE_UPDATING = 'sku-filters/group-enable-updating';
export const SKU_FILTERS_GROUP_ENABLE_UPDATED = 'sku-filters/group-enable-updated';
export const SKU_FILTERS_GROUP_EXPAND = 'sku-filters/group-expand';
export const SKU_FILTERS_GROUP_UPDATE_PROP = 'sku-filters/group-update-prop';
export const SKU_FILTERS_GROUP_EXPANDED_UPDATE_PROP = 'sku-filters/group-expanded-update-prop';
export const SKU_FILTERS_GROUP_SET_ACTIVE_GROUP_ICON = 'sku-filters/set-active-group-icon';
export const SKU_FILTERS_GROUP_NEW = 'sku-filters/group-new';
export const SKU_FILTER_GROUP_CANCEL = 'sku-filters/group-edit-cancel';
export const SKU_FILTER_GROUP_DELETING = 'sku-filters/group-deleting';
export const SKU_FILTER_GROUP_DELETED = 'sku-filters/group-deleted';
export const SKU_FILTER_GROUP_LOAD_WITH_VALUES = 'sku-filters/group-load-with-values';
export const SKU_FILTER_GROUP_ITEM_ADD_ADDITIONAL_IMAGE = 'sku-filters/group-item-add-additional-image';
export const SKU_FILTER_GROUP_ITEM_SET_ADDITIONAL_IMAGE_FILTERS = 'sku-filters/group-item-set-additional-image-filters';
export const SKU_FILTER_GROUP_ITEM_DELETE_ADDITIONAL_IMAGE = 'sku-filters/group-item-delete-additional-image';

export const SKU_FILTERS_ITEMS_LOADING = 'sku-filters/item-loading';
export const SKU_FILTERS_ITEMS_LOADED = 'sku-filters/item-loaded';
export const SKU_FILTERS_GROUP_ITEM_ENABLE_UPDATING = 'sku-filters/group-item-enable-updating';
export const SKU_FILTERS_GROUP_ITEM_ENABLE_UPDATED = 'sku-filters/group-item-enable-updated';
export const SKU_FILTERS_GROUP_ITEM_ORDER_UPDATING = 'sku-filters/group-item-order-updating';
export const SKU_FILTERS_GROUP_ITEM_ORDER_UPDATED = 'sku-filters/group-item-order-updated';
export const SKU_FILTERS_GROUP_ITEM_EXPAND = 'sku-filters/filter-group-item-expand';
export const SKU_FILTER_GROUP_ITEM_CANCEL = 'sku-filters/group-item-edit-cancel';
export const SKU_FILTER_GROUP_ITEM_LOCK_TOGGLE = 'sku-filters/group-item-lock-toggle';
export const SKU_FILTERS_GROUP_SET_ACTIVE_GROUP_ITEM_ICON = 'sku-filters/set-active-group-item-icon';
export const SKU_FILTERS_GROUP_ITEM_NEW = 'sku-filters/group-item-new';
export const SKU_FILTERS_GROUP_ITEM_SAVING = 'sku-filters/item-saving';
export const SKU_FILTERS_GROUP_ITEM_SAVED = 'sku-filters/item-saved';
export const SKU_FILTER_GROUP_ITEM_DELETING = 'sku-filters/group-item-deleting';
export const SKU_FILTER_GROUP_ITEM_DELETED = 'sku-filters/group-item-deleted';
export const SKU_FILTER_GROUP_ITEM_ADDITIONAL_POPUP_SHOW = 'sku-filters/group-item-additional-popup-show';
export const SKU_FILTER_RELATIONSHIP_OPEN_ASSIGN_FEATURE_POPUP = 'sku-filters/assign-item-popup-show';

export const SET_WIZARD_VISUALIZER = "wizard-setup/set-wizard-visualizer";
export const SET_WIZARD_LIST = "wizard-setup/set-wizard-list";
export const SET_WIZARD_PENDING_LIST = "wizard-setup/set-wizard-pending-list";
export const WIZARD_PENDING_LIST_REVERT = "wizard-setup/wizard-pending-list-revert";
export const SET_WIZARD_LIST_RECEIVED = "wizard-setup/set-wizard-list-received";
export const SET_WIZARD_POPUP_OPENED = "wizard-setup/set-popup-opened";
export const SET_WIZARD_POPUP_DISABLED_SCENES = "wizard-setup/set-popup-disabled-scenes";
export const SET_WIZARD_POPUP_EDIT_TOGGLES = "wizard-setup/set-popup-edit-toggles";
export const SET_WIZARD_POPUP_ITEM = "wizard-setup/set-popup-item";
export const UPDATE_WIZARD_POPUP_ITEM = "wizard-setup/popup-item-update";
export const SET_WIZARD_POPUP_FILTERS_OPENED = "wizard-setup/set-filters-opened";
export const SET_WIZARD_POPUP_FILTERS_SEARCH_TEXT = "wizard-setup/set-filters-search-text";
export const SET_WIZARD_FLOW_ACTIVE_MODE = "wizard-setup/set-flow-active-mode";
export const SET_WIZARD_FILTERS_LOADING = "wizard-setup/set-filters-loading";
export const UPDATE_WIZARD_NODES_COUNT = "wizard-setup/update-nodes-count";
export const SET_WIZARD_DRAGGING_GROUP_INDEX = "wizard-setup/set-dragging-group-index";
export const SET_WIZARD_CLONE_LOGIC = "wizard-setup/set-wizard-clone-logic";
export const SET_WIZARD_NODE_INPUT_FOCUSED = "wizard-setup/set-wizard-node-input-focused";
export const SET_WIZARD_BUFFER_ITEMS = "wizard-setup/set-wizard-buffer-items";
export const SET_WIZARD_COPY_EDGES = "wizard-setup/set-wizard-copy-edges";

export const FEATURES_SETUP_SET_FEATURE_GROUP = "features-setup/set-feature-group";
export const FEATURES_SETUP_SET_FEATURES_LOADING = "features-setup/set-features-loading";
export const FEATURES_SETUP_LOAD_FEATURES = "features-setup/load-features";
export const FEATURES_SETUP_SET_SEARCH_TERM = "features-setup/set-search-term";
export const FEATURES_SETUP_UPDATE_FEATURES = "features-setup/update-features";
export const FEATURES_SETUP_UPDATE_FEATURE = "features-setup/update-feature";
export const FEATURES_SETUP_CLEAR = "features-setup/clear";
export const FEATURES_SETUP_TOGGLE_POPUP_OPENED = "features-setup/toggle-popup-opened";
export const FEATURES_SETUP_DELETE_POPUP_OPENED = "features-setup/delete-popup-opened";
export const FEATURES_SETUP_SHARED_FEATURE_NAME_TOGGLE = "features-setup/shared-feature-name-toggle";
export const FEATURES_SETUP_SET_CONTENT_TYPE = "features-setup/set-content-type";
export const FEATURES_SETUP_SET_PENDING_FEATURES = "features-setup/set-pending-features";
export const FEATURES_SETUP_SET_EDIT_POPUP_FEATURE_ID = "features-setup/set-edit-popup-feature-id";
export const FEATURES_SETUP_SHOW_SHIPPING_SETUP_POPUP = "features-setup/show-shipping-setup-popup";
export const FEATURES_SETUP_SHOW_MARK_UP_DOWN_POPUP = "features-setup/show-mark-up-down-popup";
export const FEATURES_SETUP_UPDATE_FEATURES_COUNT = "features-setup/update-features-count";

export const PAYMENT_POPUP_SET_BILLING_INFO = "payment-popup/set-billing-info";
export const PAYMENT_POPUP_SET_PAYMENT_TYPE = "payment-popup/set-payment-type";
export const PAYMENT_POPUP_SET_PAYMENT_STEP = "payment-popup/set-payment-step";
export const PAYMENT_POPUP_SET_USE_CUSTOM_AMOUNT = "payment-popup/set-use-custom-amount";
export const PAYMENT_POPUP_SET_PAYMENT_AMOUNT = "payment-popup/set-payment-amount";
export const PAYMENT_POPUP_SET_ACH_INFO = "payment-popup/set-ach-info";
export const PAYMENT_POPUP_SET_CARD_INFO = "payment-popup/set-card-info";
export const PAYMENT_POPUP_SET_PAYMENT_ERRORS = "payment-popup/set-payment-errors";
export const PAYMENT_POPUP_SET_PAYMENT_STATUS = "payment-popup/set-payment-status";
export const PAYMENT_POPUP_SET_JOB_TRANSACTIONS = "payment-popup/set-job-transactions";
export const PAYMENT_POPUP_SET_REFUND_TRANSACTION_ID = "payment-popup/set-refund-transaction-id";
export const PAYMENT_POPUP_SET_REFUND_TRANSACTION_STATUS = "payment-popup/set-refund-transaction-status";

export const SET_CONTRACTS_LIST = "contracts/set-contracts-list";
export const SET_CONTRACTS_VIEW = "contracts/set-contracts-view";
export const UPDATE_CONTRACTS_LIST = "contracts/update-contracts-list";

export const PRICING_SET_SEARCH_TEXT = "pricing/set-search-text";
export const PRICING_SET_ACTIVE_SORT_TAB = "pricing/set-active-sort-tab";
export const PRICING_SET_GROUP_NAME = "pricing/set-group-name";
export const PRICING_POPUP_ALLOW = "pricing/set-allow-pricing-popup";
export const PRICING_SHOW_PRICING_POPUP = "pricing/show-pricing-popup";
export const PRICING_SET_NOTIFICATION = "pricing/set-notification";
export const PRICING_SET_FEATURE_GROUPS_CHECKED = "pricing/set-feature-groups-checked";
export const PRICING_SET_CUSTOM_GROUP_NAMES = "pricing/set-custom_group_names";
export const PRICING_SET_CATALOGS_LOADING = "pricing/set-catalogs-loading";
export const PRICING_SET_CATALOGS = "pricing/set-catalogs";
export const PRICING_SET_FEATURES_RECEIVED = "pricing/set-features-received";
export const PRICING_SET_FEATURES_LIST = "pricing/set-features-list";
export const PRICING_SET_EDITED_FEATURES = "pricing/set-edited-features";
export const PRICING_SET_FEATURES_COLUMNS = "pricing/set-features-columns";

import {ProjectScopeActionTypes as ProjectScope} from '../components/ProjectScope/ProjectScopeActions';
export { ProjectScope }

export {InstallationActionTypes as Installation} from '../components/Installations/InstallationActions';
